import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { rankings } from '@/mocks/home';
import { btn } from '@/lib/ui';

const RankingSection = () => (
  <section id="ranking" className="py-16 md:py-24">
    <div className="mx-auto w-full max-w-shell px-4 md:px-8">
      <Reveal>
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            kicker="本周热榜"
            title="正在被反复打开的八条内容"
            desc="按实时热度排序，每十分钟更新一次，榜单里的顺序就是大家此刻的关注顺序。"
          />
          <Link to="/category?sort=hot" className={`${btn('primary', 'sm')} w-fit`}>
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-fire-line text-sm" />
            </span>
            查看完整榜单
          </Link>
        </div>
      </Reveal>

      <div className="mt-10 grid gap-x-8 gap-y-1 md:grid-cols-2">
        {rankings.map((item, index) => (
          <Reveal key={item.id} delay={(index % 2) * 60}>
            <Link
              to={`/content/${item.id}`}
              className="group flex items-center gap-4 border-b border-background-200 py-4 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-semibold ${
                  index < 3
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                    : 'bg-background-100 text-foreground-500'
                }`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                  {item.title}
                </h3>
                <div className="mt-1 flex items-center gap-3 text-[11px] font-label text-foreground-500 md:text-xs">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                    {item.categoryName}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-accent-600" />
                    {item.hot}
                  </span>
                  <span className="hidden sm:inline">{item.views}</span>
                </div>
              </div>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-500 transition-colors group-hover:border-primary-400 group-hover:text-primary-600">
                <i className="ri-arrow-right-up-line text-base" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default RankingSection;